<!--
 * @Author: your name
 * @Date: 2021-08-16 14:23:41
 * @LastEditTime: 2022-05-11 11:35:41
 * @LastEditors: daidongyu daidongyu@cnuri.cn
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/add/index.vue
-->
<template>
  <div class="pay_success">
    <img src="/static/image/payerror.png" class="success_img" />
    <p class="success_text">支付失败</p>
    <p class="error_content">您的卡余额不足，请更换支付方式</p>
    <div class="success_btn" @click="handleComplete">完成</div>
  </div>
</template>
<script>
export default {
  name: "payerror",
  data() {
    return {
      shop: ""
    };
  },
  mounted() {
    const { shop } = this.$route.query;
    this.shop = shop;
  },
  methods: {
    handleComplete() {
      wx.closeWindow();
    }
  }
};
</script>
<style scoped>
.pay_success {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  text-align: center;
  box-sizing: border-box;
  padding: 17px;
}
.success_img {
  width: 50px;
  height: 50px;
}
.success_text {
  width: 100%;
  font-size: 10px;
  margin-top: 6px;
  font-weight: 400;
  line-height: 17px;
  color: #757575;
}
.error_content {
  font-size: 11px;
  font-weight: 400;
  line-height: 19px;
  color: #757575;
  margin-top: 36px;
}
.success_btn {
  width: 100%;
  height: 29px;
  font-size: 13px;
  line-height: 29px;
  color: #212121;
  text-align: center;
  background: #ffffff;
  border: 1px solid #bdbdbd;
  opacity: 1;
  border-radius: 3px;
  margin-top: 135px;
}
</style>



// WEBPACK FOOTER //
// src/payError/index.vue